import moment from "moment";
import CryptoJS from "crypto-js";
import store from "../../core/redux/store";
import { roleNames } from "../../global";
import { toast } from "react-toastify";
import { br, LiveBadge, ToastWarning, us } from "../imagepath";
import { routes } from "../routes/routes";
import { getData } from "../shared.module";
import { end_points } from "../../services/endpoints";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getAuth, signOut } from "firebase/auth";
import ReactCountryFlag from "react-country-flag";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import PropTypes from "prop-types";
import { parsePhoneNumber } from "libphonenumber-js";
import { american, crediticon, mastercardIcon, visa } from "../imagepath";

const SECRET_KEY = "healingsky";
export const SCHEDULE_DECRYPTION_KEY = "MIIEpAIBAAKCAQEAx7u2m5qvZ0kY9Qm8"; // schedule decryption key for ads schedule

const firebaseConfig = {
  apiKey: "AIzaSyDCXgxJcmYjr-pICHumbLedQ7qd-vZlDvk",
  authDomain: "turning-well-3ccb7.firebaseapp.com",
  projectId: "turning-well-3ccb7",
  storageBucket: "turning-well-3ccb7.appspot.com",
  messagingSenderId: "823835257216",
  appId: "1:823835257216:web:991311a58ae9c92278f965",
};

export const SOCKET_SERVER_URL = import.meta.env.VITE_SOCKET_SERVER_URL || "";

/**
 * Retrieves the Agora App ID from Redux global settings.
 * The app_id is fetched from the API `/settings/global-settings`
 * and stored in Redux during app initialization via `fetchGlobalSettings`.
 * @returns {string} The Agora App ID
 */
export const getAgoraAppId = () => store.getState()?.common?.globalSettings?.app_id || "";

export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || "";
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const CLIENT_ID = "897296236454-lli5f4gsc5nhk1vleh40ju5h8p9oeau1.apps.googleusercontent.com";
// "737107879926-ruk8h6g69cqvv3jci2e6eahhvhd4f6mf.apps.googleusercontent.com";
export const API_KEY = "AIzaSyALFFWAWcy_mCsOJruCL0qW67ia6KhzgZA";
// "AIzaSyDqfMlATea7npn1T3yqtrEXfDdjewgqP40";
export const SCOPES = "https://www.googleapis.com/auth/calendar";

const userDetails = store.getState().common.userDetails ? store.getState().common.userDetails : {};
const authToken = typeof window !== "undefined" ? localStorage.getItem("token") : null;
export const handleGoogleLogout = async () => {
  if (!isLoggedIn()) return;
  const auth = isLoggedIn() ? getAuth() : null;
  const user = auth && auth?.currentUser;
  try {
    if (user && auth && isLoggedIn()) {
      // Check if the user logged in using Google
      const isGoogleAccount = user?.providerData?.some(
        (provider) => provider?.providerId === "google.com",
      );

      if (isGoogleAccount) {
        try {
          await signOut(auth);
        } catch (error) {
          console.error("Logout error:", error);
        }
      }
    }
  } catch (error) {
    console.error("Error logging out:", error);
  }
};
export const isLoggedIn = () => {
  const state = store.getState();
  const userDetails = state?.common?.userDetails || {};
  const authToken = localStorage.getItem("token");
  return typeof userDetails === "object" && Object.values(userDetails).length > 0 && authToken
    ? true
    : false;
};
export const getUserId = () => {
  const state = store.getState();
  const userDetails = state?.common?.userDetails || {};
  const authToken = localStorage.getItem("token");
  return typeof userDetails === "object" && authToken && Object.values(userDetails).length > 0
    ? userDetails?._id
    : "";
};

export const getUserEmail = () => {
  const state = store.getState();
  const userDetails = state?.common?.userDetails || {};
  const authToken = localStorage.getItem("token");
  return typeof userDetails === "object" && authToken && Object.values(userDetails).length > 0
    ? userDetails?.email
    : "";
};

export const isProviderLoggedIn = () => {
  const state = store.getState();
  const userDetails = state?.common?.userDetails || {};
  const authToken = localStorage.getItem("token");
  return typeof userDetails === "object" &&
    Object.values(userDetails).length > 0 &&
    authToken &&
    userDetails?.user_role === roleNames.provider
    ? true
    : false;
};

export const isClientLoggedIn = () => {
  const state = store.getState();
  const userDetails = state?.common?.userDetails || {};
  const authToken = localStorage.getItem("token");

  return typeof userDetails === "object" &&
    Object.values(userDetails).length > 0 &&
    authToken &&
    userDetails?.user_role === roleNames.client
    ? true
    : false;
};

export const isNonProfitOrganizationLoggedIn = () => {
  const state = store.getState();
  const userDetails = state?.common?.userDetails || {};
  const authToken = localStorage.getItem("token");
  return typeof userDetails === "object" &&
    Object.values(userDetails).length > 0 &&
    authToken &&
    userDetails?.sub_user_role === "non-profit-organization"
    ? true
    : false;
};

export const homePageNavigation = () => {
  if (isProviderLoggedIn()) {
    return routes.providerpageFeed;
  } else if (isClientLoggedIn()) {
    return routes.clientPageFeed;
  } else {
    return routes.homepageConcept;
  }
};
export const toaster = {
  success: (message, options = {}) => {
    toast.success(message, {
      ...options,
      className: "custom-toast-success",
      bodyClassName: "custom-toast-body-success",
      progressClassName: "custom-toast-progress-success",
    });
  },
  error: (message, options = {}) => {
    toast.error(message, {
      ...options,
      className: "custom-toast-error",
      bodyClassName: "custom-toast-body-error",
      progressClassName: "custom-toast-progress-error",
    });
  },
  info: (message, options = {}) => {
    toast.info(message, {
      ...options,
      className: "custom-toast-info",
      bodyClassName: "custom-toast-body-info",
      progressClassName: "custom-toast-progress-info",
    });
  },
  warn: (message, options = {}) => {
    toast.warn(message, {
      ...options,
      className: "custom-toast-warning",
      bodyClassName: "custom-toast-body-warning",
      progressClassName: "custom-toast-progress-warning",
    });
  },
};

export const formatNumber = (phoneValue, country) => {
  if (!phoneValue) return "N/A";

  try {
    const phoneNum = phoneValue.includes("+") ? phoneValue : `+${phoneValue}`;

    const phoneNumber = parsePhoneNumber(phoneNum);

    if (!phoneNumber) return "N/A";

    const detectedCountry = country || phoneNumber.country;
    let formatted = "";

    if (detectedCountry === "US") {
      const national = phoneNumber.nationalNumber;
      formatted = `+${phoneNumber.countryCallingCode} (${national.slice(
        0,
        3,
      )}) ${national.slice(3, 6)}-${national.slice(6)}`;
    } else if (detectedCountry === "RU") {
      const national = phoneNumber.nationalNumber;
      formatted = `+7 (${national.slice(0, 3)}) ${national.slice(
        3,
        6,
      )}-${national.slice(6, 8)}-${national.slice(8)}`;
    } else if (detectedCountry === "IN") {
      const national = phoneNumber.nationalNumber.replace(/^0+/, "");
      formatted = `+91 ${national.slice(0, 5)}-${national.slice(5)}`;
    } else {
      formatted = phoneNumber.formatInternational();
    }

    return formatted;
  } catch (error) {
    console.error("Error formatting number:", error);
    return "N/A";
  }
};

export default toaster;
export const handleRestrictToast = (type = "") => {
  let message = "Account restricted until date of birth updated. Please submit to regain access.";
  if (type === "date") {
    message = "Account restricted until date of birth updated. Please submit to regain access.";
  }
  return toast.warning(
    <div className="custom-toast-warning">
      <img src={ToastWarning} alt="Warning Icon" className="custom-toast-warning-icon" />
      <div className="custom-toast-warning-content">
        <p className="custom-toast-warning-label">Warning</p>
        <p className="custom-toast-warning-message">
          {message ||
            "Account restricted until date of birth updated. Please submit to regain access."}
        </p>
      </div>
    </div>,
    {
      icon: false,
      className: "custom-toast-warning",
      bodyClassName: "custom-toast-body-warning",
      progressClassName: "custom-toast-progress-warning",
    },
  );
};
export const setCryptedData = (value) => {
  if (!value) return null;
  // CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
  return encodeURIComponent(CryptoJS.AES.encrypt(value, SECRET_KEY).toString());
};

export const setCryptedVideoUserData = (value) => {
  if (!value) return null;
  const valueString = typeof value === "object" ? JSON.stringify(value) : value;
  return encodeURIComponent(CryptoJS.AES.encrypt(valueString, SECRET_KEY).toString());
};

export const getDecryptedVideoUserData = (cryptedValue) => {
  if (!cryptedValue) return null;

  const bytes = CryptoJS.AES.decrypt(decodeURIComponent(cryptedValue), SECRET_KEY);
  const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
  try {
    return JSON.parse(decryptedString);
  } catch (e) {
    return decryptedString;
  }
};

export const getDecryptedData = (encryptedValue) => {
  if (!encryptedValue) return null;
  const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedValue), SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

// AES-256-GCM helpers — format: ivHex:encryptedHex:authTagHex
// GCM_KEY_HEX = pre-computed 32-byte AES key used by the backend.
// Browser has no scrypt, so derived once in Node:
//   crypto.scryptSync(SECRET_KEY, 'email-encryption-salt', 32).toString('hex')
const GCM_KEY_HEX = "9590e441af03f98774f6ec49a50c530e3916e87b9848aa568cf0e7134a92421c";
const _fromHex = (h) => new Uint8Array(h.match(/.{2}/g).map((b) => parseInt(b, 16)));
const _toHex = (buf) =>
  Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
const _getGCMKey = (usage) =>
  window.crypto.subtle.importKey("raw", _fromHex(GCM_KEY_HEX), { name: "AES-GCM" }, false, [usage]);

export const encryptGCMData = async (plaintext) => {
  try {
    if (!plaintext) return "";
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    const key = await _getGCMKey("encrypt");
    const encrypted = await window.crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      key,
      new TextEncoder().encode(plaintext),
    );
    const encArr = new Uint8Array(encrypted);
    const encBytes = encArr.slice(0, -16);
    const tagBytes = encArr.slice(-16);
    return `${_toHex(iv)}:${_toHex(encBytes)}:${_toHex(tagBytes)}`;
  } catch {
    return "";
  }
};

export const decryptGCMData = async (token) => {
  try {
    if (!token) return "";
    const decoded = decodeURIComponent(token);
    const [ivHex, encHex, tagHex] = decoded.split(":");
    if (!ivHex || !encHex || !tagHex) return token;
    const encBytes = _fromHex(encHex);
    const tagBytes = _fromHex(tagHex);
    const cipherWithTag = new Uint8Array(encBytes.byteLength + tagBytes.byteLength);
    cipherWithTag.set(encBytes, 0);
    cipherWithTag.set(tagBytes, encBytes.byteLength);
    const key = await _getGCMKey("decrypt");
    const decrypted = await window.crypto.subtle.decrypt(
      { name: "AES-GCM", iv: _fromHex(ivHex) },
      key,
      cipherWithTag,
    );
    return new TextDecoder().decode(decrypted);
  } catch {
    return token;
  }
};

// decrypt schedule for ads schedule in videos
export const decryptScheduleWithKey = (
  encryptedSchedule,
  decryptionKey = SCHEDULE_DECRYPTION_KEY,
) => {
  try {
    if (
      !encryptedSchedule ||
      (Array.isArray(encryptedSchedule) && encryptedSchedule.length === 0)
    ) {
      return [];
    }

    if (Array.isArray(encryptedSchedule)) {
      return encryptedSchedule;
    }

    if (typeof encryptedSchedule !== "string") {
      return [];
    }

    const bytes = CryptoJS.AES.decrypt(encryptedSchedule, decryptionKey);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedString) {
      console.error("Failed to decrypt schedule - invalid key or corrupted data");
      return [];
    }

    return JSON.parse(decryptedString);
  } catch (error) {
    console.error("Error decrypting schedule:", error);
    return [];
  }
};

export const encryptData = (value) => {
  if (!value) return null;
  return CryptoJS.AES.encrypt(value, SCHEDULE_DECRYPTION_KEY).toString();
};

export const decryptData = (value) => {
  if (!value) return null;
  return CryptoJS.AES.decrypt(value, SCHEDULE_DECRYPTION_KEY).toString(CryptoJS.enc.Utf8);
};

export const getCryptedJSONData = (value) => {
  if (!value) return null;

  const decryptedBytes = CryptoJS.AES.decrypt(value.toString(), SECRET_KEY);
  const decryptedString = decryptedBytes.toString(CryptoJS.enc.Utf8);

  try {
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error("Failed to parse JSON:", error);
    return null;
  }
};
export const format_MMMM_D_YYYY = (date) => {
  if (!moment(date).isValid()) {
    return date;
  }
  return moment(date).format("MMMM D, YYYY");
};
export const getTimeDiffFromNow = (createdAt) => {
  const now = moment();
  if (!moment(createdAt).isValid()) {
    return createdAt;
  }
  const date = moment(createdAt);
  const diffMinutes = now.diff(date, "minutes");
  if (diffMinutes < 60) {
    return `${diffMinutes} min`;
  }

  const hours = Math.floor(diffMinutes / 60);
  const minutes = diffMinutes % 60;
  return `${hours}:${minutes < 10 ? "0" + minutes : minutes} hrs`;
};
export const formatTime_HH_MM_AMPM = (time) => {
  if (!moment(time, "HH:mm:ss", true).isValid()) {
    return time;
  }
  return moment(time, "HH:mm:ss").format("h:mmA");
};
export const professionOptions = [
  { label: "Dentist", value: "dentist" },
  { label: "Doctor", value: "doctor" },
  { label: "Nurse", value: "nurse" },
  { label: "Therapist", value: "therapist" },
];
export const selectHereOptions = [{ label: "Group", value: "Group" }];

export const selectOneOptions = [{ label: "Group", value: "Group" }];

export const monthOptions = [
  { label: "Month", value: "Month" },
  { label: "Group", value: "Group" },
];

export const generateMonthsArray = () => {
  const currentYear = new Date().getFullYear();
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  return months.map((month) => {
    return {
      label: `${month} ${currentYear}`,
      value: `${month} ${currentYear}`,
    };
  });
};
export const overviewOptions = [
  { label: "Month", value: 12 },
  { label: "Year", value: 2024 },
];

export const yearOptions = [
  { label: "Year", value: "Year" },
  { label: "Group", value: "Group" },
];

export const authLicenseOption = {
  license: "i_am_licensed_my_license_information_is_below",
  pre_License: "i_am_pre-licensed_or_under_supervision",
  certified_License: "i_have_a_certification_my_profession_had_no_license",
  notLicensed: "i_am_not_licensed_do_not_hold_a_formal_certification",
};

export const clinicalRoleTypeOption = [
  {
    label: "PhD",
    value: "PhD",
  },
  {
    label: "MA",
    value: "MA",
  },
  {
    label: "LCSW",
    value: "LCSW",
  },
];
export const providerRoleTypeOption = [
  {
    label: "PhD",
    value: "PhD",
  },
  {
    label: "MA",
    value: "MA",
  },
  {
    label: "LCSW",
    value: "LCSW",
  },
];
export const SettingsLicenseOption = {
  license: "i_am_licensed_my_license_information_is_below",
  pre_License: "i_am_pre-licensed_or_under_supervision",
  certified_License: "i_have_a_certification_my_profession_had_no_license",
  notLicensed: "i_am_not_licensed_do_not_hold_a_formal_certification",
};
export const formatTimeTo12Hour = (timeString) => {
  const date = new Date(timeString);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12;
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  const formattedTime = `${hours}:${minutes} ${ampm}`;
  return formattedTime;
};

export const formatTimeTo12Hours = (timeString) => {
  if (!timeString) return "";
  // Split the time string into hours, minutes, and seconds
  const [hours, minutes] = timeString.split(":").map(Number);

  // Determine AM/PM
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format
  const convertedHours = hours % 12 || 12; // Use 12 instead of 0 for midnight
  const formattedHours = convertedHours < 10 ? "0" + convertedHours : convertedHours;

  // Ensure minutes are always two digits
  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;

  // Construct the formatted time
  const formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
  return formattedTime;
};

export const capitalizeFirstLetter = (str) => {
  if (typeof str === "string") {
    return str ? str.charAt(0).toUpperCase() + str.slice(1).toLocaleLowerCase() : str;
  } else return str;
};

export const capitalizeSentences = (text) => {
  if (typeof text !== "string") {
    return text;
  }
  return text
    ?.split(". ")
    ?.map((sentence) => sentence.charAt(0).toUpperCase() + sentence.slice(1))
    .join(". ");
};

export const capitalizeEachWordsCaps = (text) => {
  if (typeof text !== "string") {
    return text;
  }
  return text
    ?.split(". ")
    ?.map((sentence) => sentence.charAt(0).toUpperCase() + sentence.slice(1))
    .join(". ");
};

export const dateFormat_YYYY_MM_DD = (date) => (date ? moment(date).format("YYYY-MM-DD") : date);

export const dateFormat_DD_MM_YYYY = (date) =>
  moment(date).isValid() ? moment(date).format("DD-MM-YYYY") : date;

export const dateFormat_MM_DD_YYYY = (date) =>
  moment(date).isValid() ? moment(date).format("MM/DD/YYYY") : date;

// mmm dd, yyyy
export const dateFormat_MMM_DD_YYYY = (date) =>
  moment(date).isValid() ? moment(date).format("MMM DD, YYYY") : date;

export const globalDateFormat = (date) => {
  try {
    if (!date) return "";

    if (!store) {
      console.warn("Redux store is not available");
      return moment(date).isValid() ? moment(date).format("MM/DD/YYYY") : date;
    }

    const state = store.getState();
    const format = state?.common?.globalSettings?.dateformat || "MM/DD/YYYY";
    return moment(date).isValid() ? moment(date).format(format) : date;
  } catch (error) {
    console.error("Error in globalDateFormat:", error);
    return moment(date).isValid() ? moment(date).format("MM/DD/YYYY") : date;
  }
};

export const getGlobalDateFormatLong = () => {
  try {
    if (!store) {
      console.warn("Redux store is not available");
      return "MMMM D, YYYY";
    }

    const state = store.getState();
    const format = state?.common?.globalSettings?.dateformat || "MM/DD/YYYY";

    console.log("format", format);

    // Handle all date formats
    switch (format) {
      case "DD/MM/YYYY":
        return "D MMMM, YYYY";

      case "DD-MM-YYYY":
        return "D MMMM, YYYY";

      case "YYYY/MM/DD":
        return "YYYY, MMMM D";

      case "YYYY-MM-DD":
        return "YYYY, MMMM D";

      case "MM/DD/YY":
        return "MMMM D, YY";

      case "MM-DD-YY":
        return "MMMM D, YY";

      case "YY/MM/DD":
        return "YYYY, MMMM D";
      case "YY-MM-DD":
        return "YY, MMMM D";

      case "MM/DD/YYYY":
        return "MMMM D, YYYY";
      case "MM-DD-YYYY":
        return "MMMM D, YYYY";
      default:
        return "MMMM D, YYYY";
    }
  } catch (error) {
    console.error("Error in getGlobalDateFormatLong:", error);
    return "MMMM D, YYYY";
  }
};

export const globalDateFormatLong = (date) => {
  try {
    if (!date) return "";

    const format = getGlobalDateFormatLong();
    return moment(date).isValid() ? moment(date).format(format) : date;
  } catch (error) {
    console.error("Error in globalDateFormatLong:", error);
    return moment(date).isValid() ? moment(date).format("MMMM D, YYYY") : date;
  }
};

export const globalDateTimeFormatLong = (date) => {
  try {
    if (!date) return "";

    const dateFormat = getGlobalDateFormatLong();
    const dateTimeFormat = `${dateFormat} [at] h:mm A`;

    return moment(date).isValid() ? moment(date).format(dateTimeFormat) : date;
  } catch (error) {
    console.error("Error in globalDateTimeFormatLong:", error);
    return moment(date).isValid() ? moment(date).format("MMMM D, YYYY [at] h:mm A") : date;
  }
};

export const getGlobalMonthYearFormat = () => {
  try {
    if (!store) {
      console.warn("Redux store is not available");
      return "MMMM YYYY";
    }

    const state = store.getState();
    const format = state?.common?.globalSettings?.dateformat || "MM/DD/YYYY";

    switch (format) {
      case "DD/MM/YYYY":
      case "DD-MM-YYYY":
      case "MM/DD/YYYY":
      case "MM-DD-YYYY":
        return "MMMM YYYY";
      case "YYYY/MM/DD":
      case "YYYY-MM-DD":
        return "YYYY MMMM";
      case "MM/DD/YY":
      case "MM-DD-YY":
        return "MMMM YY";

      case "YY/MM/DD":
      case "YY-MM-DD":
        return "YY MMMM";
      default:
        return "MMMM YYYY";
    }
  } catch (error) {
    console.error("Error in getGlobalMonthYearFormat:", error);
    return "MMMM YYYY";
  }
};

export const globalMonthYearFormat = (date) => {
  try {
    if (!date) return "";

    const format = getGlobalMonthYearFormat();
    return moment(date).isValid() ? moment(date).format(format) : date;
  } catch (error) {
    console.error("Error in globalMonthYearFormat:", error);
    return moment(date).isValid() ? moment(date).format("MMMM YYYY") : date;
  }
};

export function capitalizeWords(str = "") {
  if (typeof str === "string") {
    return str
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  } else return str;
}

export const formatDateString = (dateString) => {
  const date = new Date(dateString);
  const options = {
    month: "short",
    day: "2-digit",
    year: "numeric",
    format: "MMM DD, YYYY",
  };

  return date.toLocaleDateString("en-US", options);
  // Output: "Oct 04, 2024"
};
export const formatDateStringLong = (dateString) => {
  const date = new Date(dateString);

  const options = {
    month: "long", // December
    day: "numeric", // 2 (not 02)
    year: "numeric",
  };

  return date.toLocaleDateString("en-US", options);
};

export const formatDateString1 = (dateString, format = "MMM DD, YYYY") => {
  if (!dateString) return "NA";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "NA";

  const day = String(date.getDate()).padStart(2, "0");
  const monthShort = date.toLocaleString("en-US", { month: "short" });
  const monthLong = date.toLocaleString("en-US", { month: "long" });
  const monthNum = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return format
    .replace("DD", day)
    .replace("MMM", monthShort)
    .replace("MMMM", monthLong)
    .replace("MM", monthNum)
    .replace("YYYY", year);
};

export const setLocalityLabel = (items) =>
  items.map((value) => ({
    label: value.name,
    value: value?._id !== undefined ? value?._id : value?.id,
  }));

export const GetIdLabel = (array, id, key) => {
  if (array !== undefined && array?.length > 0) {
    let temp = array?.filter((it) => it?.value === id);
    return temp[0]?.label !== undefined ? temp[0]?.label : "";
  } else {
    return "";
  }
};

export function getImageDimensions(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();

    // Set the image source to the URL
    img.src = url;

    // Wait for the image to load
    img.onload = () => {
      // Return the width and height as a dynamic string
      resolve({
        displayString: `${img.naturalWidth} by ${img.naturalHeight} pixels.`,
        dimensions: { width: img.naturalWidth, height: img.naturalHeight },
      });
      resolve();
    };

    // Handle error if the image fails to load
    img.onerror = (error) => {
      reject("Error loading image");
    };
  });
}

export const genderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Non-Binary", value: "Non-Binary" },
  { label: "Other", value: "Other" },
];

export const getCroppedImg = (imageSrc, crop) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const { width: cropWidth, height: cropHeight, x, y } = crop;
      canvas.width = cropWidth;
      canvas.height = cropHeight;

      ctx.drawImage(
        image,
        x, // Start x in source image
        y, // Start y in source image
        cropWidth, // Source width to crop
        cropHeight, // Source height to crop
        0, // Start x in canvas
        0, // Start y in canvas
        cropWidth, // Destination width in canvas
        cropHeight, // Destination height in canvas
      );

      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        const croppedImageUrl = URL.createObjectURL(blob);
        resolve(croppedImageUrl); // You can resolve as blob, base64, etc.
      }, "image/jpeg");
    };
    image.onerror = (error) => reject(error);
  });
};

export const sexualityOptions = [
  { label: "Female", value: "Female" },
  { label: "Trans Female", value: "Trans Female" },
  { label: "Male", value: "Male" },
  { label: "Trans Male", value: "Trans Male" },
  { label: "Genderqueer", value: "Genderqueer" },
  { label: "Non-binary", value: "Non-binary" },
  { label: "self-describe", value: "self-describe" },
  { label: "Prefer not to say", value: "Prefer not to say" },
];

export function removeZeros(num) {
  // Convert the number to a string, replace all 0s, and convert it back to a number
  const result = parseInt(num.toString().replace(/0/g, ""), 10);

  // Handle edge cases (if the number was all zeros or no non-zero digits were left)
  return isNaN(result) ? 0 : result;
}

export function pixelsToAspectRatio(width, height) {
  const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b)); // Helper function to calculate GCD
  const greatestCommonDivisor = gcd(width, height);
  const aspectWidth = width / greatestCommonDivisor;
  const aspectHeight = height / greatestCommonDivisor;

  return {
    width: aspectWidth,
    height: aspectHeight,
  };
}

export function isFile(content) {
  return content instanceof File;
}

export const formatTimeRange = (startTime = "", endTime = "") => {
  const start = startTime ? moment(startTime, "HH:mm:ss", true) : null;
  const end = endTime ? moment(endTime, "HH:mm:ss", true) : null;

  if (start?.isValid() && end?.isValid()) {
    return `${start.format("h:mm A")} - ${end.format("h:mm A")}`;
  }

  return startTime && endTime ? `${startTime} - ${endTime}` : "";
};

export const format_dddd_D_MMMM_YYYYY = (dateString) => {
  const date = moment(dateString); // Parse the input date string
  if (!moment(date).isValid()) {
    return date;
  }
  // Format the date as "dddd, D MMMM, YYYY"
  return date.format("dddd, D MMMM YYYY");
};
export const capitalizeFirstLetterOfEachWord = (str) =>
  str
    ?.toLowerCase()
    .replace(/\b\w+(?:['’]\w+)?/g, (word) => word.charAt(0).toUpperCase() + word.slice(1));

export const formatCapitalizeFirstLetter = (str) => {
  if (!str) return "";

  // Split into main text and parentheses (if any)
  const match = str.match(/^([^(]+)(\(.*\))?$/);
  if (!match) return str;

  const mainPart = match[1].trim();
  const bracketPart = match[2] ? match[2].trim() : "";

  // Capitalize first letter and make rest lowercase (for main part)
  const formattedMain = mainPart.charAt(0).toUpperCase() + mainPart.slice(1).toLowerCase();

  // Return main + whatever was inside parentheses (unchanged)
  return `${formattedMain}${bracketPart}`;
};

export const formatCapitalizeFirstLetterOfEachWord = (str) => {
  if (!str) return "";

  // Allow letters, spaces, commas, and periods
  const sanitizedStr = str.replace(/[^a-zA-Z\s,.]/g, "");

  const upperTitles = [
    // Medical
    "MD",
    "MBBS",
    "DO",
    "DDS",
    "DMD",
    "DM",
    "MS",
    "DNB",
    "BAMS",
    "BHMS",
    "BUMS",
    "BNYS",

    // Science & Research
    "PHD",
    "DSC",
    "MSC",
    "BSC",

    // Business / Law / Education
    "MBA",
    "BBA",
    "LLB",
    "LLM",
    "BCA",
    "MCA",
    "BED",
    "MED",

    // Certifications
    "CPA",
    "CFA",
    "CS",
    "CA",
    "ACCA",

    // Professional Boards / Associations
    "DABP",
    "DABPN",
    "DABFP",
    "DABIM",

    // Professional Roles
    "SMP",
    "FACS",
    "FAAD",
    "FRCSE",
    "FRCS",
    "FRCP",
    "FAAP",

    "ADM",
    "ADMIN",
    "CEO",
    "COO",
    "CFO",
    "CMO",
    "DIRECTOR",
    "DYDIR",
    "HOD",
    "HR",
    "GM",
    "DGM",
    "PM",
    "OM",
  ];

  const titleWithDot = ["DR", "MR", "MRS", "MS", "PROF"];

  return sanitizedStr
    .split(/(\s+)/)
    .map((word) => {
      const trimmed = word.trim();
      if (!trimmed) return word;

      // Capture punctuation
      const punctuation = trimmed.match(/[,.]$/)?.[0] || "";
      const wordWithoutPunctuation = trimmed.replace(/[,.]$/, "");
      const normalized = wordWithoutPunctuation.replace(/\./g, "").toUpperCase();
      if (upperTitles.includes(normalized)) {
        return normalized + punctuation;
      }
      if (/^[A-Za-z]\.$/.test(trimmed)) {
        return trimmed.toUpperCase();
      }
      if (wordWithoutPunctuation.includes(".")) {
        return (
          wordWithoutPunctuation
            .split(".")
            .map((part) => (part ? part.toUpperCase() : ""))
            .join(".") + punctuation
        );
      }
      if (titleWithDot.includes(normalized)) {
        return normalized.charAt(0) + normalized.slice(1).toLowerCase() + ".";
      }

      return (
        wordWithoutPunctuation.charAt(0).toUpperCase() +
        wordWithoutPunctuation.slice(1).toLowerCase() +
        punctuation
      );
    })
    .join("");
};

export const somethingElseOptions = [
  { label: "No longer needed", value: "no_longer_need_the_service" },
  { label: "Privacy concerns", value: "privacy_concerns" },
  {
    label: "Switching platforms",
    value: "switched_to_another_service",
  },
];

export const cleanObject = (obj) => {
  const newObj = {};

  for (const key in obj) {
    if (obj[key] === "") {
      // Skip empty strings
      continue;
    } else if (Array.isArray(obj[key])) {
      if (obj[key].length === 0) {
        // Skip empty arrays
        continue;
      } else {
        // Join array with comma and remove any extra spaces between items
        newObj[key] = obj[key].join(",").replace(/\s*,\s*/g, ",");
      }
    } else {
      // Add property as it is if not an empty string or array
      newObj[key] = obj[key];
    }
  }

  return newObj;
};
export function formatViews(value) {
  if (value !== undefined && value !== null) {
    if (value < 1000) {
      return value.toString(); // Less than 1k
    } else if (value < 1_000_000) {
      return `${(value / 1000).toFixed(1).replace(/\.0$/, "")}k`; // Less than 1M
    } else if (value < 1_000_000_000) {
      return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`; // Less than 1B
    } else {
      return `${(value / 1_000_000_000).toFixed(1).replace(/\.0$/, "")}B`; // 1B or more
    }
  } else {
    return "";
  }
}

// export function formatTime(time) {
//   const timeParts = time?.split(":");

//   if (timeParts?.length === 2) {
//     const [minutes, seconds] = timeParts;
//     return `${parseInt(minutes)} min ${parseInt(seconds)} sec`;
//   }

//   const totalMinutes = parseInt(time);
//   if (totalMinutes < 60) {
//     return `${totalMinutes} min`;
//   }

//   if (totalMinutes >= 60) {
//     const hours = Math.floor(totalMinutes / 60);
//     const minutes = totalMinutes % 60;
//     return `${hours}:${minutes < 10 ? "0" + minutes : minutes} hrs`;
//   }

//   return "";
// }
export function formatTime(time) {
  if (typeof time === "string") {
    const timeParts = time.split(":");
    if (timeParts.length === 2) {
      const minutes = parseInt(timeParts[0], 10);
      const seconds = parseInt(timeParts[1], 10);
      if (!isNaN(minutes) && !isNaN(seconds)) {
        const totalSeconds = minutes * 60 + seconds;
        return formatTime(totalSeconds);
      }
    }
    return "Invalid time";
  }

  if (typeof time !== "number" || isNaN(time) || time < 0) {
    return "Invalid time";
  }

  if (time === 0) {
    return "0 sec";
  }

  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = time % 60;

  const hoursStr = hours > 0 ? `${hours} hr${hours !== 1 ? "s" : ""} ` : "";
  const minutesStr = minutes > 0 ? `${minutes} min${minutes !== 1 ? "s" : ""} ` : "";
  const secondsStr = seconds > 0 ? `${seconds} sec${seconds !== 1 ? "s" : ""}` : "";

  return `${hoursStr}${minutesStr}${secondsStr}`.trim();
}
export const overlayInnerStyle = {
  backgroundColor: "#f0f0f0",
  color: "#000",
  width: "250px",
  zIndex: 1000,
};
/* export const overlayInnerStyleMini = {
  backgroundColor: "#f0f0f0",
  color: "#000",
  
  zIndex: 1000,
}; */
export const overlayInnerStyleMini = {
  backgroundColor: "#fff",
  color: "rgba(35, 31, 32, 0.8)",
  boxShadow: "0 0 100px -4px rgba(16, 24, 40, 0.1), 0 4px 20px -2px rgba(16, 24, 40, 0.03)",
  border: "0",
  borderRadius: "4px",
  padding: "5px 8px",
  textAlign: "left",
  fontSize: "14px",
  whiteSpace: "nowrap",
  maxWidth: "323px",
  width: "auto",
  zIndex: 1000,
};
export const tooltipStyle = {
  backgroundColor: "#FFFFFF",
  color: "#193B5A",
  fontFamily: "Inter, sans-serif",
  fontWeight: 400,
  fontStyle: "normal",
  fontSize: "16px",
  lineHeight: "100%",
  padding: "8px 12px",
  borderRadius: "5px",
  letterSpacing: "0%",
  border: "none",
};

export const calculateDaysAgo = (dateString) => {
  const createdDate = new Date(dateString);
  const currentDate = new Date();
  const timeDifference = currentDate - createdDate; // Difference in milliseconds
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // Convert to days

  // Format output
  return daysDifference === 0
    ? "Today"
    : daysDifference === 1
      ? "1 Day ago"
      : `${daysDifference} Days ago`;
};

export function formatLikes(count) {
  if (count >= 1_000_000_000) {
    return (count / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  }
  if (count >= 1_000_000) {
    return (count / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (count >= 1_000) {
    return (count / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return count ? (typeof count === "number" ? count?.toString() : count) : count;
}

export const removeImagesFromHTML = (htmlContent) => {
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlContent;

  const images = tempElement.getElementsByTagName("img");
  while (images.length > 0) {
    images[0].parentNode.removeChild(images[0]);
  }
  return tempElement.innerHTML;
};

export const fixBulletList = (html) => {
  const temp = document.createElement("div");
  temp.innerHTML = html;

  temp.querySelectorAll("ol").forEach((ol) => {
    // If all items do NOT start with numbers, it's actually a bullet list
    const liList = [...ol.querySelectorAll("li")];

    const isBullet = liList.every((li) => {
      const text = li.innerText.trim();
      return !/^\d+[.)]/.test(text); // not starting with 1. or 1)
    });

    if (isBullet) {
      const ul = document.createElement("ul");
      ul.innerHTML = ol.innerHTML;
      ol.replaceWith(ul);
    }
  });

  return temp.innerHTML;
};
export const customizeEnterKey = (quill) => {
  // Remove default Enter behavior
  quill.keyboard.bindings[13] = [];

  // Create new Enter handler
  quill.keyboard.addBinding(
    { key: 13 }, // Enter
    function (range, context) {
      quill.insertEmbed(range.index, "text", "\n"); // insert <br>
      quill.setSelection(range.index + 1);
      return false;
    },
  );
};

export const trimHTMLContent = (htmlContent, charLimit) => {
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlContent;
  let textContent = "";
  let truncatedHTML = "";

  const traverseNodes = (node) => {
    if (textContent.length >= charLimit) return;
    if (node.nodeType === Node.TEXT_NODE) {
      const remainingChars = charLimit - textContent.length;
      const textToAdd = node.textContent.slice(0, remainingChars);
      textContent += textToAdd;
      truncatedHTML += textToAdd;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const startTag = `<${node.nodeName.toLowerCase()}>`;
      const endTag = `</${node.nodeName.toLowerCase()}>`;
      truncatedHTML += startTag;
      for (const child of node.childNodes) {
        traverseNodes(child);
        if (textContent.length >= charLimit) break;
      }
      truncatedHTML += endTag;
    }
  };

  traverseNodes(tempElement);

  if (textContent.length < tempElement.textContent.length) {
    truncatedHTML = truncatedHTML.trim();
  }
  return truncatedHTML;
};

export const strip = (html) => {
  let doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};
export const loaderPaymentMessage =
  "Your payment is being processed. Please do not refresh or close the page until the process is complete.";

export const loaderClaimMessage =
  "Finalizing your claim and setting up your profile. Please do not refresh or close the page until the process is complete.";

export const formatDateList = (isoString) => {
  if (!isoString) return "";
  const [year, month, day] = isoString.split("T")[0].split("-");
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(new Date(`${year}-${month}-${day}`));

  return formattedDate;
  // Output: "November 28, 2024" for "2024-11-28"
};

export const sliceWord = (str = "", count = 0) => {
  if (typeof str === "string" && str?.length && str?.length > count) {
    return str.slice(0, count) + "...";
  } else return str;
};

export const feed_limit = 20;

export function removeDuplicates(arr) {
  const uniqueItems = arr.reduce((acc, current) => {
    if (!acc.some((item) => item._id === current._id)) {
      acc.push(current);
    }
    return acc;
  }, []);
  return uniqueItems;
}

export function removeLocalDuplicates(arr) {
  const uniqueItems = arr.reduce((acc, current) => {
    if (!acc.some((item) => item?.user?._id === current?.user?._id)) {
      acc.push(current);
    }
    return acc;
  }, []);
  return uniqueItems;
}
export function convertTo12HourFormat(time) {
  if (typeof time !== "string" || !time.includes(":")) {
    return "";
  }

  const parts = time.split(":");
  if (parts.length < 2 || parts.length > 3) {
    return "";
  }

  let [hours, minutes] = parts.map(Number);

  // Validate hours and minutes
  if (isNaN(hours) || isNaN(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
    return "";
  }

  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${period}`;
}

export const getExclusiveLinkProps = (value, setSubsUserId, routePath, navigate, ModalClick) => {
  const isExclusive = value?.set_as_exclusive;
  const isFromLive = value?.isFromLive || false;
  const isLive = !!value?.is_stream_ongoing;
  const isUserAvailable = isLoggedIn();

  const isValidSubscriber = async (id) => {
    if (!id) return false;

    try {
      const response = await getData(`${end_points.getFollowStatus_Api.url}/${id}`);
      if (response?.status === 201) {
        const res = response?.data?.data;
        return res?.plan_current_status === "active";
      }
    } catch (error) {
      console.error("Error checking subscriber status:", error);
    }

    return false;
  };

  const getRevenueSettings = async (encryptedProviderId) => {
    try {
      const response = await getData(
        `${end_points.direct_subscribe_and_exclusive.url}/${encryptedProviderId}`,
      );
      if (response?.status < 400) {
        return response?.data?.data;
      }
    } catch (error) {
      // ignore
    }
    return null;
  };

  const handleClick = async () => {
    const isUserAvailable = await isLoggedIn();

    if (isLive && value?.liveStreamLink) {
      window.open(value?.liveStreamLink, "_blank");
      return;
    }

    if (!isUserAvailable && isExclusive) {
      // Check provider's revenue settings before showing login modal
      const revenueSettings = value?.user_id
        ? await getRevenueSettings(setCryptedData(value?.user_id))
        : null;

      if (revenueSettings?.is_exclusive_enabled) {
        // Exclusive mode enabled → prompt login/signup
        if (ModalClick) {
          ModalClick();
        } else {
          toaster.warn("Please login");
        }
      } else {
        // Exclusive mode disabled → navigate directly
        navigate(`${routePath}/${value?.slug || value?._id}`, {
          state: { videoId: value?._id || "" },
        });
      }
      return;
    }

    if (isExclusive && isUserAvailable) {
      navigate(`${routePath}/${value?.slug || value?._id}`, {
        state: {
          videoId: value?._id || "",
        },
      });
    }

    if (value?.user_id && setSubsUserId) {
      setSubsUserId(value);
    }
  };

  return {
    to: isExclusive
      ? isLoggedIn()
        ? // ? //  isLive
          //   ? value?.liveStreamLink
          //     ? "#"
          //     : `${routes.viewProfile}/${setCryptedData(value?.user_id)}`:
          isExclusive
          ? `${routePath}/${value?.slug || value?._id}`
          : `${routePath}/${value?.slug || value?._id}`
        : "#"
      : `${routePath}/${value?.slug || value?._id}`,
    // "data-bs-toggle": isExclusive
    //   ? isLoggedIn()
    //     ? isExclusive
    //       ? ""
    //       : ""
    //     : "modal"
    //   : "",
    // "data-bs-target": isExclusive
    //   ? isLoggedIn()
    //     ? isExclusive
    //       ? ""
    //       : ""
    //     : "#signup-modal"
    //   : "",
    state: {
      videoId: value?._id,
    },
    onClick: handleClick,
  };
};

export function getCurrentStatus(status) {
  if (status === "online") {
    return <span className="online-status" />;
  } else if (status === "offline") {
    return <span className="offline-status" />;
  } else if (status === "invisible") {
    return <span className="invisible-status" />;
  }

  return <></>;
}

export const GetLiveBadge = ({ value = null, navigate }) => {
  const isUserAvailable = isLoggedIn();
  const user_id = value?.user?._id || value?.userDetails?._id || value?.user_id;
  const slugValue =
    value?.user?.slug ||
    value?.userDetails?.slug ||
    value?.slug ||
    value?.user_slug ||
    value?.user?.user_slug ||
    value?.userDetails?.user_slug ||
    "";
  const linkUrl = value ? `${routes.viewProfile}/${slugValue}` : "#";
  const liveBadgeLink = (e) => {
    if (!isLoggedIn()) return;
    if (isLoggedIn()) {
      if (navigate) {
        if (e) {
          e.stopPropagation();
          e.preventDefault();
        }
        navigate(linkUrl, {
          state: {
            encryptedId: setCryptedData(user_id),
          },
        });
      } else {
        console.warn("Navigate function is not defined");
      }
    }
  };
  return (
    <Link to="#" onClick={(e) => liveBadgeLink(e)}>
      <img className="live-h" src={LiveBadge} alt="livebadge" />
    </Link>
  );
};

GetLiveBadge.propTypes = {
  value: PropTypes.shape({
    user: PropTypes.shape({
      _id: PropTypes.string,
      slug: PropTypes.string,
      user_slug: PropTypes.string,
    }),
    userDetails: PropTypes.shape({
      _id: PropTypes.string,
      slug: PropTypes.string,
      user_slug: PropTypes.string,
    }),
    user_id: PropTypes.string,
    slug: PropTypes.string,
    user_slug: PropTypes.string,
  }),
  navigate: PropTypes.func,
};

export const GetFlagLanguageImg = ({ language = "US" }) => {
  // let langs = languages?.find((lang) => lang?.name === language);
  // let src = langs?.imageSrc || us;

  return (
    <div className="video-play video-flag">
      <span className="border-0 flag-height flag-fixed-h">
        {language?.toUpperCase() === "US" || language?.toUpperCase() === "EN" ? (
          <img src={us} alt="us"></img>
        ) : language?.toUpperCase() === "BP" ? (
          <img src={br} alt="us"></img>
        ) : (
          <ReactCountryFlag countryCode={language?.toUpperCase() || "US"} svg />
        )}
      </span>
    </div>
  );
};

GetFlagLanguageImg.propTypes = {
  language: PropTypes.string,
};

export const StarRating = ({ rating, totalStars = 5 }) => {
  const fullStars = Math.floor(rating);
  const halfStars = rating % 1 >= 0.5 ? 1 : 0;
  const emptyStars = totalStars - fullStars - halfStars;

  return (
    <ul className="rating">
      {[...Array(fullStars)].map((_, index) => (
        <li key={`full-${index}`}>
          <i className="ti ti-star-filled" />
        </li>
      ))}

      {[...Array(halfStars)].map((_, index) => (
        <li key={`half-${index}`}>
          <i className="ti ti-star-half-filled" />
        </li>
      ))}

      {[...Array(emptyStars)].map((_, index) => (
        <li key={`empty-${index}`}>
          <i className="ti ti-star" />
        </li>
      ))}

      <li>
        <span>({rating})</span>
      </li>
    </ul>
  );
};

StarRating.propTypes = {
  rating: PropTypes.number,
  totalStars: PropTypes.number,
};

export function formatTimeToAmPm(isoString) {
  // Parse the ISO string into a Date object
  const date = new Date(isoString);

  // Extract hours and minutes
  let hours = date.getHours();
  const minutes = date.getMinutes();

  // Determine AM/PM and adjust hours
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format, handle midnight as 12

  // Format minutes to always have two digits
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  // Return the formatted time
  return `${hours}:${formattedMinutes} ${ampm}`;
}

export const formatVideoPerformaceViews = (views) => {
  const numViews = parseFloat(views) || 0; // Convert to number, default to 0 if invalid

  if (Number.isInteger(numViews)) {
    return numViews.toLocaleString(); // Return whole numbers as-is with locale formatting
  }

  return numViews.toFixed(2); // Ensures 2 decimal places for non-integer numbers
};

const currentYear = new Date().getFullYear();
const yearValues = Array.from({ length: 10 }, (_, index) => currentYear - index);
const shortYearValues = Array.from({ length: 2 }, (_, index) => currentYear - index);

export const lastTenYears = yearValues?.reverse()?.map((it) => {
  return {
    label: it,
    value: it,
  };
});

export const lastTwoYears = shortYearValues?.reverse()?.map((it, index) => {
  return {
    label: index == 0 ? "Last Year" : "This Year",
    value: it,
  };
});

let navigate;

export const setNavigate = (nav) => {
  navigate = nav;
};

export const goToLogin = () => {
  if (navigate) {
    navigate("/");
  }
};

export const getMonthName = () => {
  const monthNames = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  const currentMonthIndex = new Date().getMonth();
  return monthNames[currentMonthIndex];
};

export const getFullMonthName = () => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const currentMonthIndex = new Date().getMonth();
  return monthNames[currentMonthIndex];
};

export const getMonthandDataValues = (selectedValue) => {
  const [monthName, year] = selectedValue.split(" ");
  const month = new Date(`${monthName} 1, ${year}`).getMonth() + 1;
  return { month: month, year: year };
};

export const formatMonthYear = (monthIndex, year) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return `${months[monthIndex]} ${year}`;
};

export const getLast12Months = () => {
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  const result = [];
  const currentDate = new Date();

  for (let i = 0; i < 12; i++) {
    const monthIndex = (currentDate.getMonth() - i + 12) % 12;
    const year = currentDate.getFullYear() - (i > currentDate.getMonth() ? 1 : 0);
    result.unshift(`${months[monthIndex]} ${year}`);
  }

  return result;
};
export const getLast12FullMonths = () => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const result = [];
  const currentDate = new Date();

  for (let i = 0; i < 12; i++) {
    const monthIndex = (currentDate.getMonth() - i + 12) % 12;
    const year = currentDate.getFullYear() - (i > currentDate.getMonth() ? 1 : 0);
    result.unshift(`${months[monthIndex]} ${year}`);
  }

  return result;
};
export const TicketCategories = [
  { label: "Insurance", value: "Insurance" },
  { label: "Medical", value: "Medical" },
  { label: "Billing", value: "Billing" },
  { label: "General", value: "General" },
  { label: "Health", value: "Health" },
];

export const TicketPriorities = [
  { label: "High", value: "High" },
  { label: "Medium", value: "Medium" },
  { label: "Low", value: "Low" },
];

export const GetCategoryStle = (type) => {
  if (type === "Insurance") {
    return "category-circle";
  } else if (type === "Medical") {
    return "category-circle green";
  } else if (type === "Billing") {
    return "category-circle blue";
  } else if (type === "General") {
    return "category-circle grey";
  } else if (type === "Health") {
    return "category-circle yellow";
  }
};

export const GetPriorityStle = (type) => {
  if (type === "High") {
    return "statusbox blue";
  } else if (type === "Low") {
    return "statusbox orange";
  } else if (type === "Medium") {
    return "statusbox";
  }
};

export const monthNames = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

export const getDynamicClass = (index) => {
  const classes = ["warning", "success", "info"];
  return classes[index % 3];
};
export const getTimeAgo = (isoString) => {
  const now = new Date();
  const date = new Date(isoString);

  const diffInSeconds = Math.floor((now - date) / 1000); // difference in seconds
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInMonths / 12);

  // If the time difference is within the last minute
  if (diffInSeconds < 60) {
    return "Just now";
  }

  // If the time difference is within the last hour
  if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
  }

  // If the time difference is within the last day
  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
  }

  // If the time difference is within the last 7 days
  if (diffInDays < 7) {
    return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
  }

  // If the time difference is within the last 30 days
  if (diffInDays < 30) {
    return `${Math.floor(diffInDays / 7)} week${Math.floor(diffInDays / 7) > 1 ? "s" : ""} ago`;
  }

  // If the time difference is within the last 12 months
  if (diffInMonths < 12) {
    return `${diffInMonths} month${diffInMonths > 1 ? "s" : ""} ago`;
  }

  // If the time difference is more than a year
  if (diffInYears >= 1) {
    return `${diffInYears} year${diffInYears > 1 ? "s" : ""} ago`;
  }

  // Otherwise, show the exact date and time
  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const day = daysOfWeek[date.getUTCDay()];
  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const period = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12;

  return `${day} ${String(hours).padStart(2, "0")}:${minutes} ${period}`;
};
export const BASE_URL = "https://dreamstechnologies2025.s3.us-east-2.amazonaws.com";

export const formatDate = (isoString) => {
  if (isoString !== null) {
    const date = new Date(isoString);
    const options = { year: "numeric", month: "short", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
    // Output: Jan 17, 2025
  }
};

export const formatDateToMonthLong = (isoString) => {
  if (isoString !== null) {
    const date = new Date(isoString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
    // Output: Jan 17, 2025
  }
};

export const formatTimeToAMPM = (timeString) => {
  //timeString "10:00:00"
  if (timeString) {
    const [hour, minute] = timeString.split(":").map(Number);
    const amPm = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 24-hour to 12-hour format
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${amPm}`;
    // Output: 10:00 AM
  }
};

export const formatCustomDate = (localTime) => {
  // Convert "YYYY-MM-DD hh:mm A" → "YYYY-MM-DDTHH:mm:00"
  const formattedTime = localTime.replace(
    /(\d{2}):(\d{2}) (AM|PM)/,
    (match, hour, minute, period) => {
      let hours = parseInt(hour, 10);
      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;
      return `${hours.toString().padStart(2, "0")}:${minute}:00`;
    },
  );

  // Create Date object (ensure correct format)
  const date = new Date(formattedTime.replace(" ", "T"));

  // Get formatted values
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
  const formattedTimePart = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);

  return `${formattedDate} at ${formattedTimePart}`;
};

export function trimHtmlTo255Characters(html, maxLength = 255) {
  const div = document.createElement("div");
  div.innerHTML = html;

  let charCount = 0;

  function truncate(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (charCount >= maxLength) {
        node.data = ""; // Remove excess text
      } else if (charCount + node.data.length > maxLength) {
        node.data = node.data.substring(0, maxLength - charCount); // Trim text
        charCount = maxLength;
      } else {
        charCount += node.data.length;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE && node.childNodes) {
      for (let i = 0; i < node.childNodes.length; i++) {
        truncate(node.childNodes[i]);
        if (charCount >= maxLength) {
          while (node.childNodes.length > i + 1) {
            node.removeChild(node.childNodes[i + 1]); // Remove excess nodes
          }
          break;
        }
      }
    }
  }

  truncate(div);
  return div.innerHTML;
}

export const getDateRange = (type) => {
  const today = moment();

  if (type === "week") {
    const startOfWeek = today.startOf("week").format("YYYY-MM-DD");
    const endOfWeek = today.endOf("week").format("YYYY-MM-DD");
    return { start: startOfWeek, end: endOfWeek };
  } else if (type === "month") {
    const startOfMonth = today.startOf("month").format("YYYY-MM-DD");
    const endOfMonth = today.endOf("month").format("YYYY-MM-DD");
    return { start: startOfMonth, end: endOfMonth };
  } else {
    throw new Error("Invalid type. Use 'week' or 'month'.");
  }
};

export const getDateFormatted = (date) => {
  const formattedDate = moment(date, "YYYY-MM-DD").format("MMM D, YYYY");
  return formattedDate;
};

export const getMonthFormatted = (date) => {
  const formattedDate = moment(date, "YYYY-MM-DD").format("MMM , YYYY");
  return formattedDate;
};
export const convertDateFormat = (dateString) => {
  if (dateString && dateString.split) {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  } else {
    return "";
  }
};
export const convertDateUsFormat = (dateString) => {
  if (dateString && dateString.split) {
    const [year, month, day] = dateString.split("-");
    return `${month}-${day}-${year}`;
  } else {
    return "";
  }
};
export const getRelativeDateText = (inputDate) => {
  const today = new Date();
  const givenDate = new Date(inputDate);

  const resetTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const todayDate = resetTime(today);
  const givenDateReset = resetTime(givenDate);

  const diffInDays = (givenDateReset - todayDate) / (1000 * 60 * 60 * 24);

  if (diffInDays === 0) {
    return "Today";
  } else if (diffInDays === -1) {
    return "Yesterday";
  } else if (diffInDays === 1) {
    return "Tomorrow";
  } else if (diffInDays < -1) {
    return "Past Day";
  } else {
    return "Future Day";
  }
};

export const getRelativeWeekText = (startDate, endDate) => {
  const today = new Date();

  const resetTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const todayDate = resetTime(today);
  const startOfWeek = resetTime(new Date(startDate));
  const endOfWeek = resetTime(new Date(endDate));

  if (!startDate || !endDate) return "";

  if (todayDate >= startOfWeek && todayDate <= endOfWeek) {
    return "This Week";
  }

  const lastWeekStart = new Date(startOfWeek);
  const lastWeekEnd = new Date(endOfWeek);
  lastWeekStart.setDate(startOfWeek.getDate() - 7);
  lastWeekEnd.setDate(endOfWeek.getDate() - 7);

  const nextWeekStart = new Date(startOfWeek);
  const nextWeekEnd = new Date(endOfWeek);
  nextWeekStart.setDate(startOfWeek.getDate() + 7);
  nextWeekEnd.setDate(endOfWeek.getDate() + 7);

  if (todayDate >= lastWeekStart && todayDate <= lastWeekEnd) {
    return "Next Week";
  } else if (todayDate >= nextWeekStart && todayDate <= nextWeekEnd) {
    return "Last Week";
  } else if (todayDate < lastWeekStart) {
    return "Future Week";
  } else {
    return "Past Week";
  }
};

export const getRelativeMonthText = (startDate, endDate) => {
  if (!startDate || !endDate) return "";

  const today = new Date();
  const startMonth = new Date(startDate);
  const endMonth = new Date(endDate);

  // Reset to the first day of the month for accurate comparison
  const resetToMonthStart = (date) => new Date(date.getFullYear(), date.getMonth(), 1);

  const todayMonth = resetToMonthStart(today);
  const startOfMonth = resetToMonthStart(startMonth);
  const endOfNextMonth = new Date(endMonth.getFullYear(), endMonth.getMonth() + 1, 0);

  // Determine relative month
  if (todayMonth >= startOfMonth && todayMonth <= endOfNextMonth) {
    return "This Month";
  }

  const lastMonthStart = new Date(startOfMonth.getFullYear(), startOfMonth.getMonth() - 1, 1);
  const lastMonthEnd = new Date(startOfMonth.getFullYear(), startOfMonth.getMonth(), 0);

  const nextMonthStart = new Date(startOfMonth.getFullYear(), startOfMonth.getMonth() + 1, 1);
  const nextMonthEnd = new Date(startOfMonth.getFullYear(), startOfMonth.getMonth() + 2, 0);

  if (todayMonth >= lastMonthStart && todayMonth <= lastMonthEnd) {
    return "Next Month";
  } else if (todayMonth >= nextMonthStart && todayMonth <= nextMonthEnd) {
    return "Last Month";
  } else if (todayMonth < lastMonthStart) {
    return "Future Month";
  } else {
    return "Past Month";
  }
};

export function generateDaysInMonth(year, month) {
  if (!year || !month) return [];

  const numericMonth = parseInt(month, 10);
  const daysInMonth = new Date(year, numericMonth, 0).getDate();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const currentDay = currentDate.getDate();

  let maxDay = daysInMonth;

  if (year === currentYear && numericMonth === currentMonth) {
    maxDay = currentDay - 1;
  }

  if (maxDay < 1) return [];

  return Array.from({ length: maxDay }, (_, i) => ({
    label: `${i + 1}`,
    value: `${i + 1}`,
  }));
}

export function generateMonthsInYear() {
  const monthNames = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  const monthsArray = monthNames.map((month, index) => ({
    label: month,
    value: `${index + 1}`,
  }));
  return monthsArray;
}

export function generateMonthsNameInYear(year) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();

  let filteredMonths = monthNames;

  if (year && year === currentYear) {
    filteredMonths = monthNames.slice(0, currentMonthIndex + 1);
  }

  return filteredMonths.map((month, index) => ({
    label: month,
    value: `${index + 1}`,
  }));
}

export function generatePastYearsRange(range = 100, offsetFromCurrent = 15) {
  const startYear = new Date().getFullYear() - offsetFromCurrent;
  const yearsArray = Array.from({ length: range }, (_, i) => {
    const year = startYear - i; // descending from startYear
    return { label: year.toString(), value: year.toString() };
  });
  return yearsArray;
}

// Generate the past 100 years starting from 16 years before current year
export const YearValues = generatePastYearsRange(100, 16);

export const formatDateValues = (value) => {
  if (value?.length > 1) {
    return value;
  } else {
    return `0${value}`;
  }
};

export const formatTimeNow = (dateString) => {
  const date = new Date(dateString);
  const options = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "UTC",
  };
  return new Intl.DateTimeFormat("en-US", options).format(date);
  // Output: "3:30 PM"
};

export const getTimeFromDateTime = (dateTime) => {
  const date = new Date(dateTime);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const bannerSlider = {
  loop: false,
  margin: 24,
  nav: true,
  dots: false,
  smartSpeed: 2000,
  autoplay: false,
  responsive: {
    0: {
      items: 1,
    },
    550: {
      items: 1,
    },
    768: {
      items: 1,
    },
    992: {
      items: 1,
    },
    1200: {
      items: 1,
    },
  },
};

export function getDaysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}

export const maskSSN = (ssn, showPassword) => {
  if (!ssn) {
    return "";
  }

  if (ssn.length <= 4) {
    return `XXXX`;
  }

  if (showPassword) {
    return ssn;
  }

  return ssn.replace(/^(\d{3})-(\d{2})/, "XXX-XX");
};

export const maxDate = moment().subtract(1, "days").toDate();
export const minDate = moment().subtract(120, "years").toDate();
export const maxDateUpto = moment().toDate();

export const dataURLtoFile = (dataUrl, filename) => {
  const arr = dataUrl.split(",");
  const mime = arr[0].match(/:(.*?);/)?.[1] || "image/png";
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export const isValidUrl = (value) => {
  const regex =
    /^(https?:\/\/)?([a-zA-Z0-9-_]+(\.[a-zA-Z0-9-_]+)+)(\/[a-zA-Z0-9-_]+)*(\?[a-zA-Z0-9=&]+)?$/;
  return regex.test(value);
};

export const earningsYears = Array.from({ length: 11 }, (_, i) => {
  const year = currentYear - i;
  return {
    label: i === 0 ? "This year" : String(year),
    value: year,
  };
});

export const VideoModelSlider = {
  loop: false,
  margin: 60, // Default margin
  nav: false,
  dots: true,
  smartSpeed: 2000,
  autoplay: false,
  animateOut: "slideOutUp",
  responsive: {
    0: {
      items: 1,
      nav: true,
      dots: false,
      margin: 20, // Adjusted margin for smaller screens
    },
    550: {
      items: 1,
      nav: true,
      dots: false,
      margin: 20, // Consistent margin for small screens
    },
    768: {
      items: 2,
      nav: false,
      dots: true,
      margin: 20, // Margin for medium screens
    },
    992: {
      items: 3,
      nav: false,
      dots: true,
      margin: 30, // Margin for larger medium screens
    },
    1200: {
      items: 3,
      nav: false,
      dots: true,
      margin: 30, // Default margin for large screens
    },
    1600: {
      items: 3,
      nav: false,
      dots: true,
      margin: 30, // Specific margin for extra large screens
    },
  },
};
export const ProviderCurrentlySlider = {
  loop: false,
  margin: 60, // Default margin
  nav: false,
  dots: true,
  smartSpeed: 2000,
  autoplay: false,
  animateOut: "slideOutUp",
  responsive: {
    0: {
      items: 1,
      margin: 20, // Adjusted margin for smaller screens
    },
    550: {
      items: 1,
      margin: 20, // Consistent margin for small screens
    },
    768: {
      items: 2,
      margin: 20, // Margin for medium screens
    },
    992: {
      items: 3,
      margin: 20, // Margin for larger medium screens
    },
    1200: {
      items: 3,
      margin: 20, // Default margin for large screens
    },
    1600: {
      items: 3,
      margin: 60, // Specific margin for extra large screens
    },
  },
};
export const MyHealingSkySlider = {
  loop: false,
  margin: 60, // Default margin
  nav: false, // Disabled by default (will be enabled for small screens)
  dots: true, // Enabled by default (will be disabled for small screens)
  smartSpeed: 2000,
  autoplay: false,
  animateOut: "slideOutUp",
  responsive: {
    0: {
      items: 1,
      dots: false, // Hide dots on small screens
      nav: true, // Enable navigation on small screens
      margin: 20,
    },
    550: {
      items: 1,
      dots: false, // Hide dots on small screens
      nav: true, // Enable navigation
      margin: 20,
    },
    768: {
      items: 2,
      dots: true, // Enable dots from 768px onwards
      nav: false, // Disable navigation
      margin: 20,
    },
    992: {
      items: 3,
      dots: true,
      nav: false,
      margin: 30,
    },
    1200: {
      items: 3,
      dots: true,
      nav: false,
      margin: 30,
    },
    1600: {
      items: 3,
      dots: true,
      nav: false,
      margin: 30,
    },
  },
};

export const ProviderForYouSlider = {
  loop: false,
  margin: 60, // Default margin
  nav: false,
  dots: true,
  smartSpeed: 2000,
  autoplay: false,
  animateOut: "slideOutUp",
  responsive: {
    0: {
      items: 1,
      nav: true,
      dots: false,
      margin: 20, // Adjusted margin for smaller screens
    },
    550: {
      items: 1,
      nav: true,
      dots: false,
      margin: 20, // Consistent margin for small screens
    },
    768: {
      items: 2,
      nav: false,
      dots: true,
      margin: 20, // Margin for medium screens
    },
    992: {
      items: 3,
      nav: false,
      dots: true,
      margin: 20, // Margin for larger medium screens
    },
    1200: {
      items: 3,
      nav: false,
      dots: true,
      margin: 20, // Default margin for large screens
    },
    1600: {
      items: 3,
      nav: false,
      dots: true,
      margin: 60, // Specific margin for extra large screens
    },
  },
};

export const classes = [
  "meeting-content space-event event-space success-meet",
  "meeting-content space-event event-space warning-meet",
  "meeting-content space-event event-space info-meet",
  "meeting-content space-event event-space event-meet",
];

export const handleProviderRestrictToast = () => {
  toast.warning(
    <div className="custom-toast-warning">
      <img src={ToastWarning} alt="Warning Icon" className="custom-toast-warning-icon" />
      <div className="custom-toast-warning-content">
        <p className="custom-toast-warning-label">Warning</p>
        <p className="custom-toast-warning-message">
          Account restricted until medical license information uploaded. Please submit to regain
          access.
        </p>
      </div>
    </div>,
    {
      icon: false,
      className: "custom-toast-warning",
      bodyClassName: "custom-toast-body-warning",
      progressClassName: "custom-toast-progress-warning",
    },
  );
};

export function calculateImageSize({ width, height }, format = "RGB") {
  const channels = format === "RGBA" ? 4 : 3; // Add alpha channel if needed
  const bytesPerChannel = 1; // 8 bits per channel
  const sizeInBytes = width * height * channels * bytesPerChannel;
  const sizeInKB = sizeInBytes / 1024;
  const sizeInMB = sizeInKB / 1024;

  return {
    sizeInBytes,
    sizeInKB: sizeInKB.toFixed(2),
    sizeInMB: sizeInMB.toFixed(2),
  };
}

export const upcomingEventOptions = [
  { label: "My Events", value: "" },
  { label: "Local Events", value: "local" },
  { label: "National Events", value: "national" },
  { label: "Global Events", value: "global" },
];

export const depressionSlider = {
  loop: false,
  items: 3,
  margin: 24,
  nav: false,
  dots: true,
  smartSpeed: 2000,
  autoplay: false,
  animateOut: "slideOutUp",
  responsive: {
    0: {
      items: 1,
      nav: true,
      dots: false,
    },
    550: {
      items: 1,
      nav: true,
      dots: false,
    },
    768: {
      items: 2,
    },
    992: {
      items: 3,
    },
    1200: {
      items: 3,
    },
  },
};

export const sliderVideo = {
  loop: false,
  margin: 24,
  nav: true,
  dots: false,
  smartSpeed: 2000,
  autoplay: false,
  responsive: {
    0: {
      items: 1,
    },
    550: {
      items: 1,
    },
    768: {
      items: 1,
    },
    992: {
      items: 1,
    },
    1200: {
      items: 1,
    },
  },
};

export const blogSlider = {
  loop: false,
  margin: 10,
  nav: false,
  dots: true,
  smartSpeed: 2000,
  autoplay: false,
  responsive: {
    0: {
      items: 1,
      nav: true,
      dots: false,
    },
    550: {
      items: 1,
      nav: true,
      dots: false,
    },
    768: {
      items: 1,
    },
    992: {
      items: 3,
    },
    1200: {
      items: 3,
    },
  },
};

export const initialValues = {
  availability: [],
  insurance: [],
  ages: [],
  faith: [],
  price: [],
  forQuery: [],
  conditions: [],
  audience: [],
  status: "",
  category: [],
  therapies: [],
  search: "",
};

export const videoFeedSlider = {
  centerMode: false,
  infinite: false,
  dots: true,
  arrows: false,
  slidesToShow: 3,
  speed: 1000,
  appendDots: (dots) => {
    return (
      <>
        <div className="custom-cls-live-feeds-slider">
          <ul className="slick-dots-custom">{dots}</ul>
        </div>
      </>
    );
  },
  variableWidth: true,
};
export const videoSlider = {
  centerMode: false,
  infinite: true,
  dots: true,
  arrows: false,
  slidesToShow: 3,
  speed: 1000,
  appendDots: (dots) => {
    return (
      <>
        <div className="custom-cls-video-slider">
          <ul className="slick-dots-custom">{dots}</ul>
        </div>
      </>
    );
  },
  variableWidth: true,
  responsive: [
    {
      breakpoint: 576, // When screen width is ≤ 575px
      settings: {
        dots: false, // Hide dots
        arrows: true, // Show arrows
        slidesToShow: 1,
        prevArrow: (
          <button className="slick-prev">
            <i className="ti ti-chevron-left"></i>
          </button>
        ),
        nextArrow: (
          <button className="slick-next">
            <i className="ti ti-chevron-right"></i>
          </button>
        ),
      },
    },
  ],
};

export const handlePromoCode = (event) => {
  const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];
  const key = event.key;

  // Allow navigation keys and control keys
  if (allowedKeys.includes(key) || event.ctrlKey || event.metaKey) {
    return;
  }

  // Regex to allow only letters, numbers, underscores, and hyphens
  if (!/^[a-zA-Z0-9_-]$/.test(key)) {
    event.preventDefault();
  }
};

export const roundToTwoDecimals = (num) => {
  return parseFloat(num.toFixed(3));
};

// export const formatDateClient = (isoString) => {
//   try {
//     // Check if the input is a non-empty string
//     if (typeof isoString !== "string" || !isoString.trim()) {
//       return "Invalid Date";
//     }

//     const date = new Date(isoString);

//     // Check for invalid date object
//     if (isNaN(date.getTime())) {
//       return "Invalid Date";
//     }

//     // Create formatter
//     const formatter = new Intl.DateTimeFormat("en-US", {
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "numeric",
//       minute: "2-digit",
//       hour12: true,
//     });

//     // Format and clean up (remove comma)
//     return formatter.format(date).replace(",", "");
//   } catch (error) {
//     console.error("formatDateClient error:", error);
//     return "Invalid Date";
//   }
// };

/**
 * Format a datetime string into MM/DD/YYYY hh:mm AM/PM
 * @param {any} dateInput
 * @returns {string}
 */
export const formatDateTimeClient = (dateInput) => {
  try {
    if (typeof dateInput !== "string" || !dateInput.trim()) {
      return "";
    }

    const date = new Date(dateInput);
    if (isNaN(date.getTime())) {
      return "";
    }

    // Format date as MM/DD/YYYY
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    // Format time as hh:mm AM/PM
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
  } catch (error) {
    console.error("formatDateTime error:", error);
    return "";
  }
};

const formatted = formatDate("2025-04-11T04:29:06.807Z");

export const downloadImage = async (imageUrl, fileName) => {
  try {
    const response = await fetch(imageUrl, { mode: "cors" });

    if (!response.ok) throw new Error("Network response was not ok");

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Image download failed:", error);
  }
};

export const downloadPDF = async (pdfUrl, fileName = "document.pdf") => {
  try {
    const response = await fetch(pdfUrl);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("PDF download failed:", error);
  }
};

export function SlugifyText(str) {
  if (!str || typeof str !== "string") return "";

  return str.trim().replace(/\s+/g, "-");
}

export function calculateDiscountAmount(totalAmount, discountPercent) {
  // Convert inputs to numbers and validate
  const total = Number(totalAmount);
  const discount = Number(discountPercent);

  // If inputs are invalid or not finite numbers, return 0
  if (!isFinite(total) || !isFinite(discount)) return 0;

  // If total or discount is less than or equal to 0, return 0
  if (total <= 0 || discount <= 0) return 0;

  // Clamp discount percent to 100 max to avoid negative final amounts
  const validDiscount = Math.min(discount, 100);

  const discountAmount = (total * validDiscount) / 100;
  return Math.round(discountAmount * 100) / 100; // Optional: round to 2 decimal places
}

export const getUserMetadata = async () => {
  let ipAddress = null;
  let browserName = "Unknown";
  let location = null;
  let locationName = null;

  // 1. Get IP Address
  const getIPv4 = async () => {
    try {
      const response = await fetch("https://ipv4.icanhazip.com/");
      ipAddress = (await response.text()).trim();
    } catch (error) {
      console.error("Error fetching IPv4:", error);
    }
  };

  // 2. Get Browser Name
  const detectBrowserName = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      browserName = "Google Chrome";
    } else if (userAgent.includes("Firefox")) {
      browserName = "Mozilla Firefox";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      browserName = "Safari";
    } else if (userAgent.includes("Edg")) {
      browserName = "Microsoft Edge";
    } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
      browserName = "Opera";
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
      browserName = "Internet Explorer";
    }
  };

  // 3. Get Location Coordinates using Google Maps Geolocation API
  const getUserLocation = async () => {
    // eslint-disable-next-line no-undef
    const url = `https://www.googleapis.com/geolocation/v1/geolocate?key=${REACT_APP_GOOGLE_MAPS_API_KEY}`;
    try {
      const response = await axios.post(url, { considerIp: true });
      const { lat, lng } = response.data.location;
      location = { lat, lng };
      await getLocationName(lat, lng);
    } catch (err) {
      console.error("Error getting location coordinates:", err);
    }
  };

  // 4. Get Human-readable Location Name using OpenStreetMap
  const getLocationName = async (lat, lng) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
      );
      const data = await response.json();
      const state = data.address.state;
      const country = data.address.country;
      if (state && country) {
        locationName = `${state}, ${country}`;
      }
    } catch (error) {
      console.error("Error fetching location name:", error);
    }
  };

  // Execute all
  detectBrowserName();
  await Promise.all([getIPv4(), getUserLocation()]);

  return {
    ipAddress,
    browserName,
    location,
    locationName,
  };
};

export const formatTimeStringToSecMin = (time) => {
  const parts = time.split(":");

  if (parts.length === 2) {
    const [min, sec] = parts;
    if (min === "0") {
      return `${parseInt(sec, 10)} sec`;
    } else {
      return `${min}:${sec} min`;
    }
  }

  if (parts.length === 3) {
    return `${time} hr`;
  }

  return time; // fallback
};

export const formatDateValue = (dateStr) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
  //output 11-04-2025
};

export const formatToMMDDYYYY = (dateStr) => {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date string");
  }

  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${month}/${day}/${year}`;
  //output 08/22/2025
};
export function formatDateToMDY(isoString) {
  const date = new Date(isoString);

  const month = date.getMonth() + 1; // Months are 0-based
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
  //output 08-22-2025
}

export function exportToExcel1(data, fileName) {
  if (!Array.isArray(data) || data.length === 0) {
    console.warn("No data to export");
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${fileName}.xlsx`);
}
export const formatPhoneNumber = (phone) => {
  const cleaned = phone.toString().replace(/\D/g, ""); // remove non-digits
  if (cleaned.length === 12) {
    return cleaned.replace(/(\d{4})(\d{4})(\d{4})/, "$1-$2-$3");
  }
  return phone; // return original if not 10 digits
};

export function trimHtmlTo255Characters1(html, maxLength = 255) {
  const div = document.createElement("div");
  div.innerHTML = html;

  let charCount = 0;

  function truncate(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const remaining = maxLength - charCount;
      if (remaining <= 0) {
        node.data = "";
        return true;
      }
      if (node.data.length > remaining) {
        node.data = node.data.substring(0, remaining);
        charCount = maxLength;
        return true;
      }
      charCount += node.data.length;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      for (let i = 0; i < node.childNodes.length; i++) {
        if (truncate(node.childNodes[i])) {
          // Remove remaining siblings if limit reached
          while (node.childNodes.length > i + 1) {
            node.removeChild(node.childNodes[i + 1]);
          }
          return true;
        }
      }
    }
    return false;
  }

  truncate(div);

  // Optional: remove inline styles to clean HTML
  div.querySelectorAll("[style]").forEach((el) => el.removeAttribute("style"));

  return div.innerHTML;
}

export function formatDate1(backendDate) {
  const date = new Date(backendDate);
  const now = new Date();
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(now.getDate() - 7);

  const optionsWithinWeek = {
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  const optionsOlder = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  if (date > oneWeekAgo) {
    return date.toLocaleString("en-US", optionsWithinWeek);
  } else {
    return date.toLocaleString("en-US", optionsOlder);
  }
}

export const capitalizeFirstLetterFromHTML = (html) => {
  if (!html) return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const text = doc.body.textContent || "";
  const trimmed = text.trim();

  if (!trimmed) return html;

  const capitalized = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);

  doc.body.textContent = capitalized;
  return doc.body.innerHTML;
};

export function numberToWords(num) {
  const ones = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];
  const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  if (num === 0) return "zero";
  if (num < 20) return ones[num];
  if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? "-" + ones[num % 10] : "");
  if (num < 1000)
    return (
      ones[Math.floor(num / 100)] +
      " hundred" +
      (num % 100 === 0 ? "" : " " + numberToWords(num % 100))
    );
  return num.toString(); // fallback for bigger numbers
}

export const useUpdateQueryParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const updateQueryParams = (newParams) => {
    // Get current params from URL
    const currentParams = new URLSearchParams(location.search);

    // Merge new params into current ones
    Object.entries(newParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        currentParams.set(key, value); // Add or update param
      } else {
        currentParams.delete(key); // Remove if empty
      }
    });

    // Build final query string
    const newSearch = currentParams.toString();
    navigate(`${location.pathname}?${newSearch}`, { replace: true });
  };

  return updateQueryParams;
};

export const optionTemplate = (option) => (
  <div title={option.label || option.name} className="p-dropdown-item-label">
    {option.label || option.name}
  </div>
);

export const getCardIcon = (cardBrand) => {
  switch (cardBrand) {
    case "visa":
      return visa;
    case "mastercard":
      return mastercardIcon;
    case "american_express":
      return american;
    default:
      return crediticon;
  }
};
